"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircleCheck_1 = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
var faCirclePause_1 = require("@fortawesome/pro-solid-svg-icons/faCirclePause");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
var Text_1 = __importDefault(require("shared/components/Text"));
var StatusCounter = function (_a) {
    var value = _a.value;
    return ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, lineHeight: "38px" }, { children: [
            value.confirmed && ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [value.confirmed, (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCircleCheck_1.faCircleCheck, color: "#30BC86", style: { marginLeft: 8 } })] }, "conf")),
            value.skipped && ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [value.skipped, (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCirclePause_1.faCirclePause, color: "#9CA9B0", style: { marginLeft: 8 } })] }, "skip")),
        ].filter(Boolean)
            .map(function (el, idx, arr) { return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [el, idx !== arr.length - 1 && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\u00A0\u00A0\u00B7\u00A0\u00A0" })] }, idx); }) })));
};
exports.default = StatusCounter;
